import "./libs/infiniteslidev2";
import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
import {binder} from "./libs/binder";

import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {customSelect} from "./modules/customSelect";
import {headerActions} from "./modules/headerActions";
import {animationOnScroll} from "./modules/animationOnScroll";
import {logosSlider} from "./modules/logosSlider";
import {statisticsSlider} from "./modules/statisticsSlider";
import {resourcesSlider} from "./modules/resourcesSlider";
import {tabbedSlider} from "./modules/tabbedSlider";
import {faqAccordion} from "./modules/faqAccordion";
import {testimonialsSlider} from "./modules/testimonialsSlider";
import {infoSlider} from "./modules/infoSlider";
//import {infoCards} from "./modules/infoCards";
import {copyLinkToBuffer} from "./modules/copyLinkToBuffer";
import {tableWrap} from "./modules/tableWrap";
import {anchors} from "./modules/anchors";
import {ourSolutionsStickyHolder} from "./modules/ourSolutionsStickyHolder";
import {featuredResourcesSlider} from "./modules/featuredResourcesSlider";
import {imagesSlider} from "./modules/imagesSlider";
import {ourOffices} from "./modules/ourOffices";
import {tabs} from "./modules/tabs";
import {video} from "./modules/video";
import {heroAwardsSlider} from "./modules/heroAwardsSlider";
import {parallax} from "./modules/parallax";
import {countersAnimation} from "./modules/countersAnimation";
import {leadershipMobileInfo} from "./modules/leadershipMobileInfo";
import {testimonialParallax} from "./modules/testimonialParallax";
import {accordion} from "./modules/accordion";
import {featuredCaseStudySlider} from "./modules/featuredCaseStudySlider";
import {infiniteImageSlider} from "./modules/infiniteImageSlider";
import {upcomingEventSlider} from "./modules/upcomingEventSlider";
import {tabbedSliderNav} from "./modules/tabbedSliderNav";

binder({
    bounds: {
        "html": [constants, fullHeightPage],
        "select": customSelect,
        ".header": headerActions,
        ".has-animation": animationOnScroll,
        ".logos-slider": logosSlider,
        ".statistics-slider": statisticsSlider,
        ".resources-slider": resourcesSlider,
        ".tabbed-slider-wrap": tabbedSlider,
        ".faq-section": faqAccordion,
        ".testimonials-slider": testimonialsSlider,
        ".info-slider-holder": infoSlider,
        //".advantages-section .info-list": infoCards,
        ".copy-link": copyLinkToBuffer,
        "table": tableWrap,
        ".has-anchor": anchors,
        ".our-solutions-sticky-holder": ourSolutionsStickyHolder,
        ".featured-resources-slider": featuredResourcesSlider,
        ".images-slider": imagesSlider,
        ".our-offices": ourOffices,
        ".tabs-holder": tabs,
        ".article-media-block, .images-slider": video,
        ".hero-awards-slider": heroAwardsSlider,
        ".has-parallax": parallax,
        ".has-counters-animation": countersAnimation,
        ".leadership-item": leadershipMobileInfo,
        ".testimonial": testimonialParallax,
        ".accordion": accordion,
        ".featured-case-study-slider": featuredCaseStudySlider,
        ".infinite-images-slider": infiniteImageSlider,
        ".upcoming-event-slider": upcomingEventSlider,
        ".tabbed-slider-nav-holder": tabbedSliderNav
    },
    runTests: false
});

window.initCustomSelect = function () {
    if ($("select").length) {
        jcf.setOptions("Select", {
            wrapNative: false,
            flipDropToFit: false,
            fakeDropInBody: false,
            maxVisibleItems: 6
        });

        jcf.replaceAll();
    }
};


// WEBPACK FOOTER //
// ./assets/js/global.js